import React from "react";
import ReactDom from "react-dom";
import { Navigation, Link, Router } from "react-router";
import AppHeader from "js/components/elements/sdk-header";
import { ZOOM_ICON } from "js/config.jsx";
import UserHandler from "js/utilities/user-handler";
import Validate from "js/utilities/validate";
import NoHal, {halCheck} from "js/utilities/no-hal";
import LoginButton from "html-components/LoginButton";
import Amplitude from "js/utilities/amplitude";
import TimerMixin from "react-timer-mixin";
import styles from "html-components/LoginButton.css";
import * as config from "../../config";
import LogErrrorsToZoomCloud from "js/utilities/log-errors-to-zc"

var Checkbox = React.createClass({
  getInitialState: function() {
    return {
      isChecked: false,
      handleAgreedToTOC: this.props.handleAgreedToTOC
    };
  },
  toggleChange: function() {
    this.setState({
      isChecked: !this.state.isChecked // flip boolean value
    }, function() {
      this.state.handleAgreedToTOC(this.state.isChecked)
    }.bind(this));
  },
  render: function() {
    return (
        <input
          id="agreedToTOC"
          type="checkbox"
          checked={this.state.isChecked}
          onChange={this.toggleChange} />
    );
  }
});

export default React.createClass({
  mixins: [Navigation],

  statics: {
    includeHeaderFooter: false
  },

  getInitialState: function() {
    return {
      error: null,
      loading: false,
      loaded: false,
      agreedToTOC: false
    };
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired
  },

  componentWillMount: function() {
    if(UserHandler.loggedIn()) {
      return this.context.router.push("/docs");
    }
  },

  toast: function(message) {
    var elem = document.getElementById("toast");
    elem.innerHTML = message;
    elem.className = "show";
    setTimeout(function(){
      elem.className = elem.className.replace("show", "");
      // yes this is not recommended, but we dont need to re render
      this.state.error = null
    }.bind(this), 5000);
  },

  render: function() {
    // if (UserHandler.loggedIn()){ return false; }
    var url = window.location.origin;
    if (FN_MODE !== "qa") {
      url += "/zoomsdk";
      var terms = `https://dev.facetec.com/policies/terms.html`
    }
    else {
      var terms = `https://dev.facetec.com/policies/terms.html`
    }

    var currentButtonStyle = styles.loginbutton

    let errorMessage = UserHandler.getErrorMessage()
    var isErrorMessage = false;
    if(errorMessage) {
      isErrorMessage = true;
    }
    if (this.state.error) {
      this.toast(this.state.error);
    }
    return (
      <div className="bg">
        <div className="signin">
          <div className="box">
            <div className="header">
              <img src={ZOOM_ICON} className="img"/>
              <p className="sub-title">DEVELOPER ACCESS</p>
            </div>
            <form autoComplete="off" onSubmit={this.handleSubmit}>
              <input id="input-name" ref="name" placeholder="Enter Your Name" type="text" autoFocus required/>
              <input id="input-company-name" ref="company" placeholder="Enter Your Company Name" type="text" />
              <div className="termsAndConditions">
                <Checkbox name="agreedToTOC"  handleAgreedToTOC={this.handleAgreedToTOC}/>
                <label className = "checkbox">I agree to the <a tabIndex = "-1" href={terms} target="_blank">Terms &amp; Conditions</a>
                </label>
              </div>
              <LoginButton buttonText="Submit" style={currentButtonStyle} loading={this.state.loading} loaded={this.state.loaded}></LoginButton>
              {isErrorMessage == true ? <p className="loginerror">{errorMessage}</p> : ""}
              <NoHal/>
            </form>
          </div>
        </div>
        <div id="toast"/>
      </div>
    );
  },

  handleAgreedToTOC: function(isChecked) {
    if (isChecked) {
      this.setState({agreedToTOC: true})
    }
    else {
      this.setState({agreedToTOC: false})
    }
  },

  handleSubmit: function(event) {
    this.setState({error: null, loading: true, loaded: false});
    event.preventDefault();

    var creds = {
      name: this.refs.name.value,
      companyName: this.refs.company.value,
      termsAndConditions: this.state.agreedToTOC
    };

    if (creds.name == "") {
      this.setState({error: "Please enter your Name", loading: false});
      return
    }

    if(!this.state.agreedToTOC) {
      this.setState({error: "Please agree to the Terms & Conditions", loading: false});
      return
    }

    // Instantiate Loggly
    _LTracker.push({
      "logglyKey": "98508576-85af-467e-8713-9ae93891800c",
      "tag" : "sdksite_debug_logs",
      "sendConsoleErrors": true
    });

    UserHandler.logToLogglySimple("complete-signup.jsx - handleSubmit - start");

    var method = "POST";

    var fullURL = config.API_PREFIX + "user/"+ UserHandler.getUser().email +"/complete-registration";

    // Send up email as param
    var reqBody = creds

    var requestStartTime = Date.now();
    var request = new XMLHttpRequest();
    request.open(method, fullURL, true);
    request.setRequestHeader("Content-Type", "application/json");
    request.setRequestHeader("Accept", "application/json");
    request.setRequestHeader("X-App-Token", "sSzGgFdJBW2x6tkwxlRErBfLuDmjXYqd");

    var reqHeaders = {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "X-App-Token": "sSzGgFdJBW2x6tkwxlRErBfLuDmjXYqd"
    }

    var localContextThis = this;

    request.onerror = function() {
      UserHandler.logToLogglySimple("complete-signup.jsx - handleSubmit - onerror 1 - fatal - 3101");
      var apiCallTimeEndToEnd = Date.now() - requestStartTime;

      UserHandler.logToLogglyWithAPIResponse(
        "complete-signup.jsx - handleSubmit - onerror 2 - fatal - 3101",
        method,
        fullURL,
        reqHeaders,
        reqBody,
        "No responseText when errored.",
        apiCallTimeEndToEnd
      )
      var logs = {
        "status": 999,
        "method": method,
        "ok": false,
        "url": fullURL,
        "reqBody": reqBody,
        "reqHeaders": reqHeaders,
        "originalError": request.statusText,
        "filename": "complete-signup.jsx"
      };
      LogErrrorsToZoomCloud.sendLogs(logs, reqBody, reqHeaders);

      localContextThis.setState({loading: false, error: "There was an error (3101) contacting FaceTec servers. FaceTec support has been notified of the issue.  Please try again or email support@facetec.com for assistance."});

      return;
    }

    request.onload = function() {
      UserHandler.logToLogglySimple("complete-signup.jsx - handleSubmit - onload 1");
      var apiCallTimeEndToEnd = Date.now() - requestStartTime;

      UserHandler.logToLogglyWithAPIResponse(
        "complete-signup.jsx - handleSubmit - onload 2",
        method,
        fullURL,
        reqHeaders,
        reqBody,
        request.responseText,
        apiCallTimeEndToEnd
      )

      //
      // Check response for non-happy-path flags
      //
      var responseJSON;
      try {
        responseJSON = JSON.parse(request.responseText);
      }
      catch (e) {
        UserHandler.logToLogglySimple("complete-signup.jsx - handleSubmit - onload - JSON.parse error - fatal - 3102 - error: " + e);
        var logs = {
          "status": 999,
          "method": method,
          "ok": false,
          "url": fullURL,
          "reqBody": reqBody,
          "reqHeaders": reqHeaders,
          "originalError": request.statusText,
          "filename": "complete-signup.jsx"
        };
        LogErrrorsToZoomCloud.sendLogs(logs, reqBody, reqHeaders);
        localContextThis.setState({loading: false, error: "There was an error (3102) contacting FaceTec servers. FaceTec support has been notified of the issue.  Please try again or email support@facetec.com for assistance."});
        return;
      }

      if(!responseJSON.meta || !responseJSON.meta.ok) {
        //
        // Check if user already accepted terms and condition and set zoom_sdk_available_applications, zoom_sdk_current_application to make user login
        //
        if(responseJSON.meta.ok === false && responseJSON.meta.subCode && responseJSON.meta.subCode == "acceptedTermsAndConditions") {
          UserHandler.logToLogglySimple("complete-signup.jsx - handleSubmit - onload - already accepted Terms And Conditions");
          localContextThis.setState({loading: false, error: ""});

          var temp_token = localStorage.getItem("zoom_sdk_temp_token")
          if(temp_token) {
            UserHandler.setToken(temp_token);
            localStorage.removeItem("zoom_sdk_temp_token")
          }


          localContextThis.context.router.push("/docs");
          return;
        }
        else if(responseJSON.meta.ok === false && responseJSON.meta.subCode && responseJSON.meta.subCode == "acceptTermsAndConditions") {
          UserHandler.logToLogglySimple("complete-signup.jsx - handleSubmit - onload - terms and condition not accepted - fatal - 3105");
          localContextThis.setState({loading: false, error: "Please accept Terms and Conditions"});
          return;
        }
        else {
          UserHandler.logToLogglySimple("complete-signup.jsx - handleSubmit - onload - malformed response meta - fatal - 3105");
          localContextThis.setState({loading: false, error: "There was an error (3105) contacting FaceTec servers. FaceTec support has been notified of the issue.  Please try again or email support@facetec.com for assistance."});
          return;
        }
      }

      localContextThis.setState({loading: false});

      if(responseJSON && responseJSON.meta && responseJSON.meta.ok) {
          // Happy path, Set user & token to make user login
          var temp_token = localStorage.getItem("zoom_sdk_temp_token")
          if(temp_token) {
            UserHandler.setToken(temp_token);
            localStorage.removeItem("zoom_sdk_temp_token")
          }
          localContextThis.setState({loading: false, error: ""});
          localContextThis.context.router.push("/docs");
          return;
      }
      else {
        UserHandler.logToLogglySimple("complete-signup.jsx - handleSubmit - onload - email send response incorrect 2 - fatal - 3107");
        localContextThis.setState({loading: false, error: "There was an error (3107) contacting FaceTec servers. FaceTec support has been notified of the issue.  Please try again or email support@facetec.com for assistance."});
      }
    }

    request.send(JSON.stringify(reqBody));
    UserHandler.logToLogglySimple("complete-signup.jsx - handleSubmit - sent");
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/complete-signup.jsx